import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi.js";
import appconfig from "../appconfig";

const AdminHomePageLinksProvider = {
	async update(id, data, jwtToken) {
		const response = await BifrostBackendNestApi.put(`/admin-home-links/${data.id}`,
			{
				tenantId: appconfig.tenantId,
				path: data.path,
				name: data.name,
				pagePermission: data.pagePermission,
				icon: data.icon
			}, {
				headers: {
					Authorization: jwtToken
				}
			});
		return response.data;
	},
	async create(data, jwtToken) {
		const response = await BifrostBackendNestApi.post(`/admin-home-links`,
			{
				tenantId: appconfig.tenantId,
				path: data.path,
				name: data.name,
				pagePermission: data.pagePermission,
				icon: data.icon
			}, {
				headers: {
					Authorization: jwtToken
				}
			});
		return response.data;
	},
	async findAll(jwtToken) {
		const response = await BifrostBackendNestApi.get(`/admin-home-links?tenantId=${appconfig.tenantId}`,
			{
				headers: {
					Authorization: jwtToken
				}
			});
		return response.data;
	},
	async remove(id, jwtToken) {
		const response = await BifrostBackendNestApi.delete(`/admin-home-links/${id}`,
			{
				headers: {
					Authorization: jwtToken
				}
			});
		return response.data;
	}
};

export default Object.freeze(AdminHomePageLinksProvider);
